import { render, staticRenderFns } from "./_export_records_form.vue?vue&type=template&id=5057712c&"
import script from "./_export_records_form.vue?vue&type=script&lang=js&"
export * from "./_export_records_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports